/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest } from './FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest';
import {
    instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest,
    FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSON,
    FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped,
    FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSON,
} from './FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest';

/**
 * @type FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct
 * 
 * @export
 */
export type FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct = FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest;

export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct {
    return FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest(json)) {
        return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSON(json: any): any {
    return FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSONTyped(value?: FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest(value)) {
        return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSON(value as FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest);
    }

    return {};
}

